import { useSpring, animated as a } from "@react-spring/web";
import { Html } from "@react-three/drei";
import { useRive } from "@rive-app/react-canvas";
import { useEffect, useMemo } from "react";
import { findChildStartsWithKey } from "../../../../utils/FindObjects";
import { MarkerLabels } from "../../../ui/MarkerLabel";

const PowerFloorApplication = ({ object3d, ...props }) => {
  const flashTarget = useMemo(() => {
    return findChildStartsWithKey("rive_position_p_app_powerfloor", object3d);
  }, []);
  const flashTarget2 = useMemo(() => {
    return findChildStartsWithKey("rive_position_p_app_powerfloor2", object3d);
  }, []);
  const marker = useMemo(() => {
    return findChildStartsWithKey("markers_a_powerfloor", object3d);
  }, []);

  return (
    <>
      <FlashAnimation riveSrc="./assets/rive/enrx_flash.riv" position={flashTarget.position} />
      <FlashAnimation batteryStyle riveSrc="./assets/rive/enrx_battery.riv" position={flashTarget2.position} />
      <MarkerLabels node={marker} />
    </>
  );
};

const FlashAnimation = ({ riveSrc, batteryStyle, ...props }) => {
  const revealSpring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 2000 },
  });

  const { rive, RiveComponent } = useRive({
    src: riveSrc,
    autoplay: false,
  });

  useEffect(() => {
    rive && rive.play();
  }, [rive]);

  return (
    <group {...props}>
      {/* <mesh>
        <sphereGeometry args={[0.1]} />
      </mesh> */}
      <Html
        style={{
          pointerEvents: "none",
        }}
      >
        <a.div
          style={{
            width: batteryStyle ? "8vw" : "15vw",
            height: "20vw",
            transform: "translate(-50%,-50%)",

            opacity: revealSpring.opacity,
          }}
        >
          <RiveComponent />
        </a.div>
      </Html>
    </group>
  );
};

export default PowerFloorApplication;
